// // import { getRequest, postRequest } from './apiRequests'; // Adjust the path to your API request helper
// import AgentImprovement from "../../agent/pages/AgentImprovement/AgentImprovement";
// import { getRequest } from "./getRequest";
// import { postRequest } from "./postRequest";
// // Function to handle GET request
// // export function getAgentPortalDataAPI(callId) {
// //   const baseUrl = process.env.REACT_APP_GET_WORK_SCREEN_DATA_API;
// //   const url = `${baseUrl}&customerId=${callId}`;
// //   return getRequest(url);  // Perform GET request
// // }

// // Function to handle POST request
// export function postAgentPortalDataAPI(payload) {
//   // const { agentId } = payload; // Extract agentId from the payload
//   const baseUrl = process.env.REACT_APP_GRAPH_API;
//   // console.log(baseUrl);
//   // console.log(payload);
//   return postRequest(baseUrl, payload); // Perform POST request
// }
// // export function getAgentImprovementAPI(payload) {
// //   // const { agentId } = payload; // Extract agentId from the payload
// //   const baseUrl = process.env.REACT_APP_GET_AGENTIMPROVMENT_API;
// //   console.log(baseUrl);
// //   return getRequest(baseUrl); // Perform POST request
// // }
// export function getAgentImprovementAPI(type = "agent") {
//   const baseUrl = process.env.REACT_APP_GET_AGENTIMPROVMENT_API;

//   if (!baseUrl) {
//     console.error("Base URL for the API is undefined.");
//     return;
//   }
//   // Check if the base URL already contains a query parameter
//   const url = baseUrl.includes("?")
//     ? `${baseUrl}&type=${type}`
//     : `${baseUrl}?type=${type}`;

//   // console.log("Constructed API URL:", url);
//   return getRequest(url); // Perform GET request
// }

// export function getProcessImprovementAPI(type = "process") {
//   const baseUrl = process.env.REACT_APP_GET_AGENTIMPROVMENT_API;

//   if (!baseUrl) {
//     console.error("Base URL for the API is undefined.");
//     return;
//   }
//   // Check if the base URL already contains a query parameter
//   const url = baseUrl.includes("?")
//     ? `${baseUrl}&type=${type}`
//     : `${baseUrl}?type=${type}`;

//   // console.log("Constructed API URL:", url);
//   return getRequest(url); // Perform GET request
// }

// export async function postTransactionDetailsApi(payload) {
//   //!hardcoding the pagination
//   payload = {
//     CallIds: payload.CallIds,
//     limit: 10,
//     page: 1,
//     sortBy: "",
//     sortOrder: "",
//     searchColumn: "",
//     search: "",
//   };
//   const baseUrl =
//     "https://azulvision.azurewebsites.net/api/transaction-level-details?code=sBAJVmZ_1UU1yCck0gP2yGO4YtpL22G6dhYU1MFNxKSaAzFunW4DIA==";

//   const response = await postRequest(baseUrl, payload);
//   const embeddedData = response[0];
//   embeddedData.data = embeddedData?.data?.map((data) => {
//     const {
//       AgentName,
//       CallID,
//       CallRecording,
//       Category,
//       EngagementDate,
//       FollowUpStatus,
//       MemberID,
//       MemberName,
//       QualityOfCall,
//       CallType,
//       HID,
//       ReferralType,
//       MemberFName,
//       MobileNumber,
//       urgency,
//       agentScore,
//       callCategory,
//     } = data;
//     return {
//       agentName: AgentName,
//       callId: CallID,
//       recordingUrl: CallRecording,
//       category: Category,
//       engagementDate: EngagementDate,
//       status: FollowUpStatus,
//       memberId: MemberID,
//       memberName: MemberName,
//       qualityOfCall: QualityOfCall,
//       insight: "Details",
//       workOn: "Work",
//       CallType: CallType,
//       HID: HID,
//       ReferralType: ReferralType,
//       MemberName: MemberFName,
//       MobileNumber: MobileNumber,
//       urgency: urgency,
//       agentScore: agentScore,
//       callCategory: callCategory,
//     };
//   });
//   return embeddedData;
// }

// import { getRequest, postRequest } from './apiRequests'; // Adjust the path to your API request helper
import AgentImprovement from "../../agent/pages/AgentImprovement/AgentImprovement";
import { getRequest } from "./getRequest";
import { postRequest } from "./postRequest";
import CryptoJS from "crypto-js";

// Helper to get auth headers
const getAuthHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return {
    Authorization: `Bearer ${authToken}`,
  };
};

// Function to handle POST request
export function postAgentPortalDataAPI(payload) {
  const baseUrl = process.env.REACT_APP_GRAPH_API;
  return postRequest(baseUrl, payload, {
    headers: getAuthHeaders(),
  });
}

export function getAgentImprovementAPI(type = "agent") {
  const baseUrl = process.env.REACT_APP_GET_AGENTIMPROVMENT_API;

  if (!baseUrl) {
    console.error("Base URL for the API is undefined.");
    return;
  }

  const url = baseUrl.includes("?")
    ? `${baseUrl}&type=${type}`
    : `${baseUrl}?type=${type}`;

  return getRequest(url, {
    headers: getAuthHeaders(),
  });
}

export function getProcessImprovementAPI(type = "process") {
  const baseUrl = process.env.REACT_APP_GET_AGENTIMPROVMENT_API;

  if (!baseUrl) {
    console.error("Base URL for the API is undefined.");
    return;
  }

  const url = baseUrl.includes("?")
    ? `${baseUrl}&type=${type}`
    : `${baseUrl}?type=${type}`;

  return getRequest(url, {
    headers: getAuthHeaders(),
  });
}

const SECRET_KEY = "1234567890abcdef1234567890abcdef";

const decryptFunction = (ciphertext) => {
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (e) {
    console.error("Decryption failed:", e);
    return ciphertext;
  }
};

export function getAgentFeedbackAPI(userId, agentId = null) {
  console.log("TTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT");

  const baseUrl = process.env.REACT_APP_AGENT_FEEDBACK;

  if (!baseUrl) {
    console.error("Base URL for the API is undefined.");
    return;
  }

  if (!userId) {
    console.error("User ID is required for fetching feedback.");
    return;
  }

  const url = baseUrl.includes("?")
    ? `${baseUrl}&userId=${userId}&agentId=${agentId}`
    : `${baseUrl}?userId=${userId}&agentId=${agentId}`;

  return getRequest(url, {
    headers: getAuthHeaders(),
  });
}

export async function postAgentFeedbackAPI(payload) {
  if (!payload) {
    console.error("Payload is required for posting feedback.");
    return;
  }

  if (!payload.senderUserId || !payload.messageText) {
    console.error(
      "Missing required fields: senderUserId, receiverUserId, or messageText",
    );
    return;
  }

  const feedbackPayload = {
    senderUserId: payload.senderUserId,
    receiverUserId: payload.receiverUserId,
    messageText: payload.messageText,
    senderName: payload.senderName || "Unknown",
    senderRole: payload.senderRole || "Unknown",
    isResponseExpected: payload.isResponseExpected || false,
    parentFeedbackId: payload.parentFeedbackId || null,
    threadId: payload.threadId || null,
  };

  const baseUrl = process.env.REACT_APP_AGENT_FEEDBACK;

  if (!baseUrl) {
    console.error("Base URL for the API is undefined.");
    return;
  }

  const response = await postRequest(baseUrl, feedbackPayload, {
    headers: getAuthHeaders(),
  });

  const decRes = decryptFunction(response?.encryptedResponse);
  return response;
}

export async function postTransactionDetailsApi(payload) {
  payload = {
    CallIds: payload.CallIds,
    limit: 10,
    page: 1,
    sortBy: "",
    sortOrder: "",
    searchColumn: "",
    search: "",
  };

  const baseUrl = process.env.REACT_APP_TRANSACTION_DETAILS_API;
  const response = await postRequest(baseUrl, payload, {
    headers: getAuthHeaders(),
  });

  const embeddedData = response[0];

  embeddedData.data = embeddedData?.data?.map((data) => {
    const {
      AgentName,
      CallID,
      CallRecording,
      Category,
      EngagementDate,
      FollowUpStatus,
      MemberID,
      MemberName,
      QualityOfCall,
      CallType,
      HID,
      ReferralType,
      MemberFName,
      MobileNumber,
      urgency,
      agentScore,
      callCategory,
      FeedbackStatus,
    } = data;

    console.log(
      "[postTransactionDetailsApi] Raw FeedbackStatus from API:",
      FeedbackStatus,
      "| type:",
      typeof FeedbackStatus,
    );

    return {
      agentName: AgentName,
      callId: CallID,
      recordingUrl: CallRecording,
      category: Category,
      engagementDate: EngagementDate,
      engagementDate1: EngagementDate,
      status: FollowUpStatus,
      memberId: MemberID,
      memberName: MemberName,
      qualityOfCall: QualityOfCall,
      insight: "Details",
      workOn: "Work",
      CallType,
      HID,
      ReferralType,
      MemberName: MemberFName,
      MobileNumber,
      urgency,
      agentScore,
      callCategory,
      FeedbackStatus,
    };
  });

  return embeddedData;
}

//   import React, { useState, useEffect, useMemo } from 'react';
// import "./metricsCard.css";
// import transactionVector from "../../../assets/images/transactionVector.png";
// import TransactionPopup from './TransactionPopup';
// import { useDispatch, useSelector } from 'react-redux';
// import { fetchTransactionDetailsInit } from '../../../redux/slices/agentHomeSlice';

// function MetricsCard({ metrics, dataAccessor }) {
//   const dispatch = useDispatch();
//   const [showPopup, setShowPopup] = useState(false);

//   const PopuptableData = useSelector((state) => state.agentHome.transactionTable);
//   const currentPage = useSelector((state) => state.operationHome.table.currentPage);
//   const pageSize = useSelector((state) => state.operationHome.table.pageSize);
//   const recommendations = useSelector(
//     (state) => state.agentHome.recommendations?.[dataAccessor] || []
//   );

//   const AgentRecommendation = useMemo(() => {
//     return recommendations[currentPage - 1]?.callIds.split(",") || [];
//   }, [recommendations, currentPage]);
//   console.log("Deepika:", PopuptableData,AgentRecommendation);
//   useEffect(() => {
//     console.log("Recommendations:", recommendations);  // Check the recommendations data
//     if (!AgentRecommendation || AgentRecommendation.length === 0) {
//       console.log("Skipping API call: AgentRecommendation is not ready");
//       return;
//     }
//     const payload = {
//       "CallIds": AgentRecommendation,
//       "limit": Number(pageSize),
//       "page": Number(currentPage),
//       "sortBy": "",
//       "sortOrder": "",
//       "searchColumn": "",
//       "search": ""
//     };

//     dispatch(fetchTransactionDetailsInit(payload));
//   }, [AgentRecommendation, pageSize, currentPage, dispatch]);

//   const calculatePercentage = (value, total) => (total > 0 ? (value / total) * 100 : 0);

//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     const options = { year: "numeric", month: "long", day: "numeric" };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };

//   const togglePopup = () => {
//     setShowPopup(!showPopup);
//   };

//   return (
//     <div className="card shadow-sm agent-improvement-metrics-card-container">
//       <div className="card-body">
//         <div className='subcontainer-Title'>Interaction & Impact Overview</div>
//         <div className='subContainer'>
//           <div className="mb-3">
//             <div className="agent-improvement-progress-container-date">
//               <label className="agent-improvement-metrics-date d-block">Date Of First Identification:</label>
//               <p className="mb-0 agent-improvement-metrics-identification-date">{formatDate(metrics?.CreatedOn)}</p>
//             </div>
//           </div>
//           <div className="interaction-container mb-3">
//             <label className="agent-improvement-metrics-label d-block">
//               No. Of Interactions <span className="affected">Affected </span>
//             </label>
//             <div className="agent-improvement-progress-container">
//               <div className="progress agent-improvement-progress-bar-half agent-improvement-progress-custom">
//                 <div
//                   className="progress-bar agent-improvement-progress-bar-warning"
//                   style={{ width: `${calculatePercentage(metrics?.NoOfInteractionsaffected, metrics?.totalCalls)}%` }}
//                   role="progressbar"
//                   aria-valuenow={calculatePercentage(metrics?.NoOfInteractionsaffected, metrics?.totalCalls)}
//                   aria-valuemin="0"
//                   aria-valuemax="100"
//                 ></div>
//               </div>
//               <span className="agent-improvement-progress-ratio">{metrics?.NoOfInteractionsaffected}/{metrics?.totalCalls}</span>
//             </div>
//           </div>

//           <div className="interaction-container mb-3">
//             <label className="agent-improvement-metrics-label d-block">No. Of Escalations</label>
//             <div className="agent-improvement-progress-container">
//               <div className="progress agent-improvement-progress-bar-half agent-improvement-progress-custom">
//                 <div
//                   className="progress-bar agent-improvement-progress-bar-success"
//                   style={{ width: `${calculatePercentage(metrics?.NoOfEscalations, metrics?.totalCalls)}%` }}
//                   role="progressbar"
//                   aria-valuenow={calculatePercentage(metrics?.NoOfEscalations, metrics?.totalCalls)}
//                   aria-valuemin="0"
//                   aria-valuemax="100"
//                 ></div>
//               </div>
//               <small className="agent-improvement-progress-ratio">{metrics?.NoOfEscalations}/{metrics?.totalCalls}</small>
//             </div>
//           </div>

//           <div className="interaction-container mb-3">
//             <label className="agent-improvement-metrics-label d-block">No. Of Interactions Affected In Last 24 Hours</label>
//             <div className="agent-improvement-progress-container">
//               <div className="progress agent-improvement-progress-custom-2 ">
//                 <div
//                   className="progress-bar agent-improvement-progress-bar-warning"
//                   style={{ width: `${calculatePercentage(metrics?.NoOfInteractionsAffectedIn24Hours, metrics?.totalCalls)}%` }}
//                   role="progressbar"
//                   aria-valuenow={calculatePercentage(metrics?.NoOfInteractionsAffectedIn24Hours, metrics?.totalCalls)}
//                   aria-valuemin="0"
//                   aria-valuemax="100"
//                 ></div>
//               </div>
//               <small className="agent-improvement-progress-ratio">{metrics?.NoOfInteractionsAffectedIn24Hours}/{metrics?.totalCalls}</small>
//             </div>
//           </div>
//         </div>

//         <div className="text-end agent-improvement-metrics-details-link" style={{ position: 'relative', top: '-10px', left: "46%" }}>
//           <button
//             className="btn btn-link text-decoration-none"
//             style={{ color: '#FFFFFF', gap: "7px" }}
//             onClick={togglePopup}
//           >
//             <span><img src={transactionVector} alt="link icon" /></span> Transaction Level Details
//           </button>
//         </div>
//       </div>
//       <TransactionPopup isVisible={showPopup} onClose={togglePopup} />
//     </div>
//   );
// }

// export default MetricsCard;
